import {Controller} from '@hotwired/stimulus'
import Inputmask from "inputmask"

export default class extends Controller {
  static targets = ['input']
  static values = {mask: String}

  connect() {
    Inputmask({mask: this.maskValue}).mask(this.inputTarget);
  }
}